import HeroContent from "./HeroContent";
import HeroVisual from "./HeroVisual";
import "./Hero.css";

const HERO_STATS = [
  { value: "10+", label: "Years combined" },
  { value: "50+", label: "Projects delivered" },
  { value: "24/7", label: "Client support" },
];

const Hero = () => (
  <section id="home" className="hero">
    <div className="hero__bg" aria-hidden="true">
      <div className="hero__blob hero__blob--a" />
      <div className="hero__blob hero__blob--b" />
      <div className="hero__grid" />
    </div>

    <div className="container hero__inner">
      <HeroContent
        title="Our vision is to"
        titleAccent="expand your vision"
        lede="Ant Fire Labs is your one-stop partner for software products, web services and elite tech talent — from need analysis and solution design to delivery and ongoing support."
        stats={HERO_STATS}
      />
      <HeroVisual />
    </div>

    <a href="#services" className="hero__scroll" aria-label="Scroll to services">
      <span />
    </a>
  </section>
);

export default Hero;
